<!-- 预置车辆运营赢积分接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KM43Y46",
                "parkingCode": "20160723162730110",
                "thirdBillCode": "thirdbill0001",
                "prestoreAmount": "20",
                "payOrigin": "3",
                "payOriginRemark": "微信",
                "paymentMode": "12",
                "paymentModeRemark": "第三方余额"
            },
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                }
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台向某个车辆预置车辆运营积分，用于后续车场端车辆自动抵扣运营积分(平台端将自动调用pointsUse接口，实现第三方运营积分进行抵扣)",
                t_url: this.commonUrls.test+"setPoints",
                p_url: this.commonUrls.prod+"setPoints",
                precondition: "无",
                fitSystem: "云停车场，vems停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'appId', info2: '是', info3: 'String', info4: '微信分配的appId' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方系统订单号，每条账单唯一（预置失败，再次预置时，该账单号要与首次预置的账单号应一致），用于重复同步时判断重复和对账（不超过30位）' },
                        { info1: 'rule', info2: '是', info3: 'String', info4: '抵扣规则，x（整数）运营积分抵扣y（Decimal）元，形式为"x:y"。样例"10:10.00"' },
                        { info1: 'max', info2: '是', info3: 'Integer', info4: '单次最高低扣运营积分值' },
                        { info1: 'pointsValue', info2: '是', info3: 'Integer', info4: '预置运营积分值，为大于等于0的整数' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注(字段长度不得超过20位)' },
                        { info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注(字段长度不得超过20位)' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/setPoints.vue